import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
const tomos = [{
  n: "Tomo I",
  t: "El Diagnóstico que Predice el Éxito del Caso",
  d: "Aprende a identificar desde el inicio qué casos serán predecibles y cuáles requieren una planificación diferente."
}, {
  n: "Tomo II",
  t: "El Secreto para Crear Espacio sin Comprometer la Estética",
  d: "Descubre cuándo utilizar IPR, expansión u otras alternativas para crear espacio sin generar movimientos indeseados."
}, {
  n: "Tomo III",
  t: "Attachments Inteligentes: La Clave del Movimiento Preciso",
  d: "Aprende a seleccionar los attachments adecuados según el movimiento que deseas conseguir."
}, {
  n: "Tomo IV",
  t: "Cómo Resolver los Casos que la Mayoría Evita",
  d: "Protocolos paso a paso para tratar Clases II, Clases III y mordidas cruzadas con mayor seguridad."
}, {
  n: "Tomo V",
  t: "El Sistema para Controlar el Torque y el Movimiento Radicular",
  d: "Evita el tipping no deseado y consigue un mejor control biomecánico durante el tratamiento."
}, {
  n: "Tomo VI",
  t: "El Protocolo de Finalización que Reduce los Refinamientos",
  d: "Aprende cómo cerrar correctamente un caso, solicitar refinamientos cuando sean necesarios y obtener resultados más predecibles."
}];
export function Tomos() {
  return <section className="w-full bg-[#0f2547] py-14 sm:py-20" data-id="element-225" data-mp="3oepgrik14qqm">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-226" data-mp="3oe61yapoeigt">
        <SectionHeading dark eyebrow="📲 Acceso inmediato" title="¿Qué recibirás inmediatamente después de tu compra?" data-id="element-227" data-mp="3sf9ean8ilwda" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-228" data-mp="692nw0hqew49">
          {tomos.map((t, i) => <motion.div key={t.n} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i % 3 * 0.08
        }} className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm transition-all hover:border-[#2196f3]/40 hover:bg-white/[0.08]" data-id="element-229" data-mp="231mckpd12ywg" data-mpi={i}>
              <div className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-[#2196f3]/10 blur-xl transition-opacity group-hover:opacity-100" data-id="element-230" data-mp="29zigmegrzuzj" />
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#2196f3] px-3 py-1 font-head text-xs font-800 uppercase tracking-wide text-white" data-id="element-231" data-mp="2iydr42qurr8n">
                📘 {t.n}
              </span>
              <h3 className="mt-3 font-head text-base font-800 leading-snug text-white sm:text-lg" data-id="element-232" data-mp="2soyojmusippz">
                {t.t}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-233" data-mp="2nq44yip00x4t">
                {t.d}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}